'use es6';

import { connect } from 'react-redux';
import LayoutBuilder from 'LayoutBuilderUI/components/LayoutBuilder';
import { selectSectionIfEmpty } from 'LayoutBuilderUI/actions/layoutActions';
import { getIsFileManagerOpen, getIsDraggingWithinApp, getDraggedItemType } from 'LayoutBuilderUI/selectors/userInterface';
import { getSelectedType } from 'EmailEditorUI/redux/selectors/selected';
import prefetchChunks from 'EmailComponents/utils/prefetchChunks';
import { getSectionIds, getShouldShowHubspotBranding, getHasVisibleSectionsForActiveBreakpoint } from 'EmailEditorUI/redux/selectors/sectionSelectors';
import { getIsReadOnlyMode } from 'EmailEditorUI/redux/selectors/ReadOnlySelector';
import { getHasHubspotVideoAccess } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getIsOnboardingActive } from 'EmailEditorUI/redux/selectors/OnboardingSelectors';
import { scrollContainer } from 'LayoutBuilderUI/actions/userInterfaceActions';
import { requestStarted, requestCompleted } from 'redux-request-state/util/requestStateCheckers';
import { getSavedSectionMetaRequest } from 'EmailEditorUI/redux/selectors/requestStatesSelectors';
import { withErrorBoundary } from 'EmailEditorUI/hoc/withErrorBoundary';
export const lbuiChunksPrefetcher = prefetchChunks([() => import( /* webpackChunkName: 'rich-text-with-dnd-config' */'LayoutBuilderUI/components/fields/overrides/RichTextWithDndConfig')]);
const mapStateToProps = state => {
  const fetchSectionMetaRequest = getSavedSectionMetaRequest(state);
  return {
    sections: getSectionIds(state),
    hasVisibleSectionsForActiveBreakpoint: getHasVisibleSectionsForActiveBreakpoint(state),
    selectedType: getSelectedType(state),
    showHubspotBranding: getShouldShowHubspotBranding(state),
    isFileManagerOpen: getIsFileManagerOpen(state),
    isOnboardingActive: getIsOnboardingActive(state),
    isReadOnlyMode: getIsReadOnlyMode(state),
    isDraggingWithinApp: getIsDraggingWithinApp(state),
    itemType: getDraggedItemType(state),
    hasHubspotVideoAccess: getHasHubspotVideoAccess(state),
    showLoading: requestStarted(fetchSectionMetaRequest) && !requestCompleted(fetchSectionMetaRequest)
  };
};
const mapDispatchToProps = {
  selectSectionIfEmpty,
  scrollContainer
};
const LayoutContainer = connect(mapStateToProps, mapDispatchToProps)(LayoutBuilder);
export default lbuiChunksPrefetcher(withErrorBoundary(LayoutContainer, true));